import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const GarageFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.7798 2.38965L4.73047 7.75587V18.2507H9.42905V16.4289H6.51217V8.66674L11.7798 4.82524L17.0475 8.66674V10.6153H18.8292V7.75587L11.7798 2.38965Z" />
      <path
        fillRule="evenodd"
        d="M20.4482 19.3438C20.4482 19.9797 19.9437 20.5 19.313 20.5C18.82 20.5 18.3155 20.1994 18.1894 19.575H13.5801C13.454 20.1994 12.9495 20.5 12.4564 20.5C11.8258 20.5 11.3213 19.9797 11.3213 19.3438V15.9675L11.5277 15.5426H10.771V14.4759H12.0322L12.9953 12.4641H18.7741L19.7373 14.4759H20.9985V15.5426H20.2418L20.4482 15.9675V19.3438ZM14.878 16.6192H12.9609V17.6864H14.4577C14.8472 18.0098 15.3404 18.2183 15.8815 18.2183C16.4227 18.2183 16.9158 18.0098 17.3054 17.6864H18.8021V16.6192H16.8851L16.8552 16.6609C16.6313 16.9727 16.2819 17.1742 15.8815 17.1742C15.4812 17.1742 15.1318 16.9727 14.9079 16.6609L14.878 16.6192Z"
      />
    </SvgIcon>
  );
});
